import { getFetchRepositories } from 'common/services/repositories.service';
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { findRelevantSensorAuthorization } from '../RepositoriesModal/repositories-modal.service';
import { LoadingTemplate } from '../RepositoriesModal/repositories-modal.components';
import { fetchOrgs } from '../RepositoriesModalV2/repositories-modal.service';
import { OAuthProviders } from 'common/utils/assets.utils';
import {
  MAX_NUM_OF_REPOS_TO_FETCH,
  isCheckNumberOfReposistories
} from './auth.utils';
import {
  ScaledReposMessage,
  ScaledReposButtons,
  ReauthV1Message,
  ReauthV1Buttons
} from './auth.sections';

const ReauthModal = ({
  openRepositoriesModal,
  sensor_authorization_id,
  gitIntegrations,
  reauthParams,
  state: { repositories } = {},
  onApproveReauth,
  onApproveReauthV2,
  toggleModal,
  toggleSnackBar,
  isFetchLargeRepos,
  isGitstreamFlow,
  isReauthV2Enabled
}) => {
  const sensorAuthorizationRepositories = repositories.filter(
    r => r.sensor_authorization_id === sensor_authorization_id
  );
  const [loading, setLoading] = useState(true);
  const [isScaledRepos, setIsScaledRepos] = useState(false);
  const [, setError] = useState(true);
  const [unavailableRepositories, setUnavailableRepositories] = useState([]);
  const [alreadySelectedRepositories, setAlreadySelectedRepositories] =
    useState([]);

  const git_sensor =
    findRelevantSensorAuthorization(gitIntegrations, sensor_authorization_id) ||
    {};

  const { sensor_name = '', sensor_id } = git_sensor;

  const getRepositoriesFromProvider = async () => {
    try {
      const providerRepositories = await getFetchRepositories({
        sensor_authorization_id,
        cacheId: _.get(reauthParams, 'cacheId', null)
      });

      const selectedRepos = _.intersectionBy(
        providerRepositories,
        sensorAuthorizationRepositories,
        'http_url'
      );

      setAlreadySelectedRepositories(selectedRepos);

      setUnavailableRepositories(
        _.differenceBy(
          sensorAuthorizationRepositories,
          providerRepositories,
          'http_url'
        )
      );
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setError(_.get(e, 'response.status', null));
    }
  };

  const getNumberOfRepositories = async () => {
    let orgs = [];
    try {
      orgs = (await fetchOrgs(sensor_authorization_id)) || [];
    } catch (err) {}

    try {
      const numberOfRepositories = _.sum(
        orgs.map(({ total_private_repos }) => total_private_repos)
      );
      if (
        numberOfRepositories > MAX_NUM_OF_REPOS_TO_FETCH ||
        isReauthV2Enabled
      ) {
        setIsScaledRepos(true);
        setLoading(false);
      } else {
        getRepositoriesFromProvider();
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isReauthV2Enabled) {
      setIsScaledRepos(true);
      setLoading(false);
    } else if (isCheckNumberOfReposistories({ isFetchLargeRepos, sensor_id })) {
      getNumberOfRepositories();
    } else {
      getRepositoriesFromProvider();
    }
  }, []);

  if (!!loading) return <LoadingTemplate />;

  return (
    <Flex direction='column' height='100%' width='100%'>
      <Flex direction='column' height='100%' padding='big'>
        <Flex justify='space-between' items='center' pb='medium'>
          <Flex direction='row' pb='medium' items='center' content='center'>
            <img
              src={_.get(OAuthProviders[sensor_name.toLowerCase()], 'logo')}
              alt=''
            />
            <Text size='x-x-x-large' pl='1rem' weight='300'>
              {`Reauthorize ${_.capitalize(sensor_name)} Integration`}
            </Text>
          </Flex>
        </Flex>
        <Flex justify='space-between' direction='column' grow='1'>
          {isScaledRepos ? (
            <ScaledReposMessage />
          ) : (
            <ReauthV1Message
              unavailableRepositories={unavailableRepositories}
              alreadySelectedRepositories={alreadySelectedRepositories}
              sensorAuthorizationRepositories={sensorAuthorizationRepositories}
              isGitstreamFlow={isGitstreamFlow}
            />
          )}
        </Flex>
      </Flex>
      <Separator direction='horizontal' width='100%' height='1px'></Separator>
      {isScaledRepos ? (
        <ScaledReposButtons
          sensor_authorization_id={sensor_authorization_id}
          reauthParams={reauthParams}
          onApproveReauthV2={onApproveReauthV2}
          toggleModal={toggleModal}
          toggleSnackBar={toggleSnackBar}
        />
      ) : (
        <ReauthV1Buttons
          gitIntegrations={gitIntegrations}
          openRepositoriesModal={openRepositoriesModal}
          sensor_authorization_id={sensor_authorization_id}
          reauthParams={reauthParams}
          onApproveReauth={onApproveReauth}
          toggleModal={toggleModal}
          toggleSnackBar={toggleSnackBar}
          isGitstreamFlow={isGitstreamFlow}
        />
      )}
    </Flex>
  );
};

export default ReauthModal;
